import { toastr } from "react-redux-toastr"
import api from "../../../services/api"

import axios from "axios"
import Baseurlaxios from "../../../services/baseurlaxios"

import BaseurlApi from "../../../services/baseurlapi"

// export function GettodosPdd(codigoPuxada, DatIni, DatFim, CodCet) {
//     return (dispatch) => {
//         apiFHWebApi.get(`/GetPedidoAppPorData?codigoPuxada=${codigoPuxada}&data_inic=${DatIni}&data_fim=${DatFim}&codigo_cliente=${CodCet}`
//         , {
//             //withCredentials: true,
//             // auth: {
//             //     username: 'usuario',
//             //     password: 'password'
//             // },

//             headers: {
//                 "Access-Control-Allow-Origin": "*",
//                 "Content-Type": "application/x-www-form-urlencoded"
//             },
//         })
//             .then(response => {
                
//                 dispatch({
//                     type: "GET_DATA_TODOS_ORDER",
//                     payload: response
//                 })
//             })
//             .catch(error => {
//                 toastr.error("Erro orderActions GettodosPdd: " + error)
//             })
//     };
// }

export function GetPdd(codigoPuxada, DatIni, DatFim, CodCet) {
    return (dispatch) => {
        axios.get(`${BaseurlApi}/GetPedidoAppPorData?codigoPuxada=${codigoPuxada}&data_inic=${DatIni}&data_fim=${DatFim}&codigo_cliente=${CodCet}`
        , {
            //withCredentials: true,
            // auth: {
            //     username: 'usuario',
            //     password: 'password'
            // },

            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                
                dispatch({
                    type: "GET_DATA_ORDER",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro orderActions GetPdd: " + error)
            })
    };
}

export function PegaStatusPedido(codigoPuxada, CodPddApp) {
    return (dispatch) => {
        axios.get(`${BaseurlApi}/getStatusPedidoPorCodigo?codigoPuxada=${codigoPuxada}&cod_pedido_app=${CodPddApp}`
        , {
            //withCredentials: true,
            // auth: {
            //     username: 'usuario',
            //     password: 'password'
            // },

            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_STATUS",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro orderActions PegaStatusPedido: " + error)
            })
    };
}

export function PegaItensPedido(codigoPuxada, CodPddApp) {
    return (dispatch) => {
        axios.get(`${BaseurlApi}/getPedidoAppPorCodigo?codigoPuxada=${codigoPuxada}&cod_pedido_app=${CodPddApp}`
        , {
            //withCredentials: true,
            // auth: {
            //     username: 'usuario',
            //     password: 'password'
            // },

            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_ITENS",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro orderActions PegaItensPedido: " + error)
            })
    };
}

// export function PegapayloadPedido(codigoPuxada, CodPddApp) {
//     return (dispatch) => {
//          axios.get(`${BaseurlApi}/getPayloadStatusPedido?codigoPuxada=${codigoPuxada}&cod_pedido_app=${CodPddApp}`
//         , {
//             //withCredentials: true,
//             // auth: {
//             //     username: 'usuario',
//             //     password: 'password'
//             // },

//             headers: {
//                 "Access-Control-Allow-Origin": "*",
//                 "Content-Type": "application/x-www-form-urlencoded"
//             },
//         })
//             .then(response => {
//                 dispatch({
//                     type: "GET_DATA_PAYLOAD",
//                     payload: response
//                 })
//             })
//             .catch(error => {
//                 toastr.error("Erro orderActions PegapayloadPedido: " + error)
//             })
//     };
// }

export function getDataTdsRevendas() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Dist/TodosDist`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_LSTRVD",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro orderActions getDataTdsRevendas: " + error)
            })
    };
}

export function enviaOrderRegistros(arrayprice_Enviar_cod_pedido_app,arrayprice_Enviar_cod_status_pedido, codpuxada, usuario
    , DatIni, DatFim, CodCet) {
    return (dispatch) => {
        api.post(`/Tb_log_Envio_Order/IncluiLogOrder?CodPuxada=${codpuxada}&Usuario=${usuario}`, {
            "Arraycod_pedido_app": arrayprice_Enviar_cod_pedido_app
           , "Arraycod_status_pedido": arrayprice_Enviar_cod_status_pedido
        }
        )
            .then(response => {
                dispatch([
                    GetPdd(codpuxada, "1900-01-01","1900-01-01", 0)
                ])
                dispatch([
                    GetPdd(codpuxada, DatIni, DatFim, CodCet)
                ])
            })
            .catch(error => {
                toastr.error("Erro orderActions enviaOrderRegistros: " + error.statusText)
            })
    }
}